import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PublicGuard } from './guards/public.guard';
import { AuthGuard } from './guards/auth.guard';
import { updatePasswordGuard } from './guards/update-password.guard';

const routes: Routes = [
  {
    path: 'public',
    canActivate: [PublicGuard],
    loadChildren: () =>
      import('./public/public-routing.module').then(
        (m) => m.PublicRoutingModule
      ),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./secured/secured-routing.module').then(
        (m) => m.SecuredRoutingModule
      ),
  },
  {
    path: '',
    redirectTo: 'public',
    pathMatch: 'full',
  },
  { path: '**', redirectTo: 'public', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
